/** Formatierung für die deutsche Oberfläche */
export const fmtDate = (iso: string | Date | null | undefined): string => {
  if (!iso) return '–';
  const s = iso instanceof Date ? iso.toISOString().slice(0, 10) : String(iso).slice(0, 10);
  const [y, m, d] = s.split('-');
  if (!y || !m || !d) return String(iso);
  return `${d}.${m}.${y}`;
};
export const fmtDateTime = (iso: string | Date | null | undefined): string => {
  if (!iso) return '–';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
export const fmtNum = (n: number | string | null | undefined, digits = 0): string =>
  n == null || n === ''
    ? '–'
    : Number(n).toLocaleString('de-DE', { minimumFractionDigits: digits, maximumFractionDigits: Math.max(digits, 2) });
export const fmtEur = (n: number | string | null | undefined): string =>
  n == null || n === ''
    ? '–'
    : Number(n).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
export const fmtHa = (n: number | string | null | undefined): string =>
  n == null || n === '' ? '–' : String(Math.round(Number(n) * 100) / 100).replace('.', ',');
/** Heutiges Datum in lokaler Zeit (toISOString wäre UTC und liefert nachts bis 2 Uhr den Vortag) */
export const todayIso = (): string => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
export const addDays = (iso: string, d: number): string => {
  const x = new Date(iso + 'T00:00:00Z');
  x.setUTCDate(x.getUTCDate() + d);
  return x.toISOString().slice(0, 10);
};
export const daysBetween = (a: string, b: string): number =>
  Math.round((new Date(b + 'T00:00:00Z').getTime() - new Date(a + 'T00:00:00Z').getTime()) / 86400000);
export const initialsOf = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .map((p) => p[0]!.toUpperCase())
    .slice(0, 3)
    .join('');
